import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "smaastund_cookie_consent_v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const existing = localStorage.getItem(STORAGE_KEY);
    if (!existing) {
      // Slight delay so banner doesn't fight with initial paint
      const t = setTimeout(() => setVisible(true), 600);
      return () => clearTimeout(t);
    }
  }, []);

  const save = (choice) => {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ choice, ts: new Date().toISOString() })
    );
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-[60]"
    >
      <div className="bg-[#2C302E] text-white rounded-3xl shadow-2xl p-6 md:p-7 relative">
        <button
          aria-label="Lukk"
          onClick={() => save("essential")}
          data-testid="cookie-banner-close"
          className="absolute top-4 right-4 text-white/50 hover:text-white"
        >
          <X className="w-4 h-4" />
        </button>

        <div className="flex items-center gap-2 mb-3">
          <Cookie className="w-5 h-5 text-[#D97B66]" strokeWidth={1.5} />
          <p className="text-xs uppercase tracking-[0.2em] text-white/60 font-medium m-0">
            Informasjonskapsler
          </p>
        </div>

        <p className="font-heading text-lg md:text-xl font-light leading-snug mb-2">
          Vi bruker cookies på Småstund.
        </p>
        <p className="text-sm text-[#A8A8A0] leading-relaxed mb-5">
          Nødvendige cookies trengs for at handlekurven og kjøp skal fungere. I tillegg ønsker vi å
          bruke analyse-cookies (Google Analytics) for å forbedre nettsiden. Du bestemmer.{" "}
          <Link to="/cookies" className="underline text-white hover:text-[#D97B66]">
            Les mer
          </Link>
          .
        </p>

        <div className="flex flex-col sm:flex-row gap-2">
          <button
            onClick={() => save("all")}
            data-testid="cookie-accept-all"
            className="bg-[#D97B66] hover:bg-[#C66A55] text-white rounded-full px-5 py-2.5 text-sm font-medium transition-colors flex-1"
          >
            Godta alle
          </button>
          <button
            onClick={() => save("essential")}
            data-testid="cookie-accept-essential"
            className="bg-white/10 hover:bg-white/20 text-white rounded-full px-5 py-2.5 text-sm font-medium transition-colors flex-1"
          >
            Bare nødvendige
          </button>
        </div>
      </div>
    </div>
  );
}
